
import { Bar } from "vue-chartjs";

const MAX_CHAR_PER_LINE = 12;

/**
 * Memecah nama ruangan jadi beberapa baris (Chart.js merender array tick
 * sebagai multi-baris) sehingga nama panjang tetap terbaca tanpa rotasi.
 */
function wrapLabel(text: string): string[] {
  const lines: string[] = [];
  let line = "";
  text.split(" ").forEach(word => {
    if (line && (line + " " + word).length > MAX_CHAR_PER_LINE) {
      lines.push(line);
      line = word;
    } else {
      line = line ? line + " " + word : word;
    }
  });
  if (line) lines.push(line);
  return lines.length ? lines : [text];
}

/**
 * Grafik batang kepatuhan (%) per ruangan/unit untuk satu modul PPI.
 * Nama ruangan selalu tercetak di sumbu-X (tidak perlu disorot mouse).
 */
export default {
  extends: Bar,
  props: {
    labels: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    seriesLabel: { type: String, default: "Kepatuhan (%)" }
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.seriesLabel,
            data: this.data,
            backgroundColor: this.data.map((v: number | null) =>
              v === null ? "#BDBDBD" : v >= 80 ? "#43A047" : v >= 50 ? "#FB8C00" : "#E53935"
            )
          }
        ]
      };
    }
  },
  data() {
    return {
      // Menuliskan angka kepatuhan di atas batang — nilai ikut terbaca tanpa tooltip.
      valueLabelPlugin: {
        afterDatasetsDraw(chart: any) {
          const ctx = chart.ctx;
          ctx.save();
          ctx.font = "11px Roboto, sans-serif";
          ctx.fillStyle = "#424242";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          chart.data.datasets.forEach((dataset: any, i: number) => {
            const meta = chart.getDatasetMeta(i);
            if (meta.hidden) return;
            meta.data.forEach((element: any, index: number) => {
              const value = dataset.data[index];
              const model = element._model;
              ctx.fillText(value === null ? "-" : value + "%", model.x, model.y - 4);
            });
          });
          ctx.restore();
        }
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        layout: { padding: { top: 16 } },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                min: 0,
                max: 100,
                stepSize: 20,
                callback: (value: number) => value + "%"
              }
            }
          ],
          xAxes: [
            {
              maxBarThickness: 64,
              ticks: {
                // Nama ruangan selalu tampil: tidak di-skip, tidak dirotasi,
                // dipecah jadi beberapa baris agar muat di bawah batangnya.
                autoSkip: false,
                maxRotation: 0,
                minRotation: 0,
                fontSize: 11,
                padding: 4,
                callback: (value: string) => wrapLabel(String(value))
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: (item: any) =>
              `Kepatuhan: ${item.yLabel === null ? "-" : item.yLabel + "%"}`
          }
        }
      }
    };
  },
  mounted() {
    this.addPlugin(this.valueLabelPlugin);
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart(this.chartData, this.options);
      }
    }
  }
};
